<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-flex xs12>
                <v-card>
                     <v-card-text>
                         <v-container fluid>
                              <v-layout row wrap>
                                  <v-col cols="12">
                                      <strong>Confirm Availability and Total Rate</strong>
                                  </v-col>

                                  <v-col cols="12" md="2" xl="3">
                                      <strong>Total Rate:</strong>
                                  </v-col>

<!--
                                  <v-col cols="9">
                                      <div v-for="(unit, index) in reservation.units">
                                          <strong>{{ unit.room.name }}</strong> (
                                              {{ unit.occ_adults ? unit.occ_adults + ' adults' : '' }}, 
                                              {{ unit.occ_children ? unit.occ_children + ' young children' : '' }}, 
                                              {{ unit.occ_oldchildren ? unit.occ_oldchildren + ' older children' : '' }}, 
                                              {{ unit.occ_babies ? unit.occ_babies + ' babies' : '' }}
                                          )
                                          {{ unit.rate_type.name }} for {{ reservation.stay_length }} nights
                                      </div>
-->

                                  <v-col cols="12" md="10" xl="9">
                                      <v-layout wrap>

                                      <v-col cols="12" class="ma-0 pa-0">
                                          <v-radio-group
                                              v-model="quoteNotPossible"
                                              row
                                              autocomplete
                                          >
                                              <v-radio label="A quote cannot be given at this time" :value="1"></v-radio>
                                              <v-radio label="A quote can be given" :value="0"></v-radio>
                                          </v-radio-group>
                                      </v-col>


                                      <v-col cols="12"
                                             class="ma-0 pa-0"> 
                                        <fieldset
                                             v-for="(unit, index) in reservation.units" 
                                             v-if="!quoteNotPossible">
                                          <legend>{{ unit.room.name }} using {{ unit.rate_type.name }}:</legend>

                                          <v-col cols="12" class="pa-0 ma-0">
                                              <b>Guests:</b>  {{ unit.occ_adults ? unit.occ_adults + " adults" : "" }}
                                                       {{ unit.occ_oldchildren ? unit.occ_oldchildren + " older" + (unit.occ_oldchildren == 1 ? " child" : " children") : "" }}
                                                       {{ unit.occ_children ? unit.occ_children + (unit.occ_children == 1 ? " child" : " children") : "" }}
                                                       {{ unit.occ_babies ? unit.occ_babies + (unit.occ_babies == 1 ? " baby" : " babies") : "" }}
                                          </v-col>

                                          <v-container fluid>
                                               <v-layout row>
                                                  <v-col cols="12" 
                                                         v-if="unit.offer"
                                                         class="ma-0 pa-0" 
                                                         style="color: red;">
                                                      <b>Valid Offer:</b> {{ unit.offer.name }}
                                                  </v-col>
  
                                                  <v-col cols="12" class="ma-0 pa-0 d-none d-sm-flex">
                                                      <v-container fluid>
                                                          <v-layout row wrap>
                                                              <v-col cols="6" sm="3">
                                                                  <b>Date</b>
                                                              </v-col>
                                                              <v-col cols="12" sm="2">
                                                                  <b>Rate ({{ reservation.hotel.currency.currency_code }})</b> for {{ unit.total_guests }} guests
                                                              </v-col>
                                                              <v-col cols="6" sm="2">
                                                                  <b>Total Daily Rate ({{ reservation.hotel.currency.currency_code }})</b>
                                                              </v-col>
                                                              <v-col cols="6" sm="2">
                                                                  <b>Commission Rate (%)</b>
                                                              </v-col>
                                                              <v-col cols="6" sm="3">
                                                                  <b>Commission Amount ({{ reservation.hotel.currency.currency_code }})</b>
                                                              </v-col>
                                                          </v-layout>
                                                      </v-container>
                                                  </v-col>


                                                  <v-col cols="12"
                                                         class="ma-0 pa-0" 
                                                         v-for="(quoteDate, index) in unit.std_rates">
                                                      <v-container fluid>
                                                          <v-layout row wrap>
                                                              <v-col cols="12" sm="3" class="ma-0 pa-0">
                                                                  <b>{{ dateFormatDDMYYYYDay(quoteDate.date) }}</b>
                                                              </v-col>
                                                              <v-col cols="12" sm="2" class="ma-0 pa-0">
                                                                  <v-text-field v-model="quoteDate.rate" 
                                                                                v-on:keyup="updateTotalRatesFromSeparateRates()"
                                                                                v-on:change="updateTotalRatesFromSeparateRates()"></v-text-field>
                                                              </v-col>
                                                              <v-col cols="12" sm="2" class="ma-0 pa-0">
                                                                  {{ (quoteDate.rate ? quoteDate.rate : '-') }}
                                                                  <span class="d-md-none">{{ reservation.hotel.currency.currency_code }}</span>
                                                              </v-col>
                                                              <v-col cols="12" sm="2" class="ma-0 pa-0">
                                                                  {{ quoteDate.commission }}% 
                                                                  <span class="d-md-none">commission</span>
                                                              </v-col>
                                                              <v-col cols="12" sm="3" class="ma-0 pa-0">
                                                                  {{ (quoteDate.rate ? ((quoteDate.rate / 100) * quoteDate.commission).toFixed(2) : '-') }}
                                                              </v-col>
                                                          </v-layout>
                                                      </v-container>
                                                  </v-col>

                                                  <v-col cols="12" md="3" class="ma-0 pa-0">
                                                      <b>Total Rate ({{ reservation.hotel.currency.currency_code }}):</b>
                                                  </v-col>
                                                  <v-col cols="12" md="3" class="ma-0 pa-0">
                                                          <v-text-field 
                                                              class="text-right align-right"
                                                              v-on:change="updateSeparateRatesFromTotalRates()"
                                                              v-model="totalRates"
                                                          ></v-text-field>
                                                  </v-col>
                                                  <v-col cols="2">
                                                  </v-col>
                                                  

                                              </v-layout>
                                          </v-container>
                                        </fieldset>
                                      </v-col>

                               </v-layout>
                               </v-col>

                                  <v-col cols="12" md="3">
                                      <strong>Deposit:</strong>
                                  </v-col>

                                  <v-col cols="12" md="9">
                                      <div v-if="reservation.depositRequired"><b>Deposit required at time of booking {{ reservation.deposit_amount_local.toFixed(2) }} {{ reservation.hotel.currency.currency_code }}</b></div>
                                      <div v-if="reservation.is_advance_payment">Full pre-payment charged to the client by i-escape to secure the booking</div>
                                      <div v-if="!reservation.is_advance_payment && reservation.type_of_hotel == 'UPF' && reservation.hotel.collect_deposit == 1">Amount charged to the client by i-escape to secure the booking</div>
                                      <div v-if="!reservation.is_advance_payment && reservation.type_of_hotel == 'ARR' && (!reservation.voucher_key)">i-escape has not charged the clients card</div>
                                  </v-col>

                                  <v-col cols="12" md="3">
                                      <strong>Commission:</strong>
                                  </v-col>
                                  <v-col cols="12" md="9">
                                      Charged at time of booking {{ (reservation.commission_amount_local ? reservation.commission_amount_local.toFixed(2) : "0.00") }} {{ reservation.hotel.currency.currency_code }}
                                  </v-col>

                                  <!-- This needs to be per unit -->
                                  <v-col cols="12" md="3">
                                      <strong>Payment Policy:</strong>
                                  </v-col>

                                  <v-col cols="12" md="9">
                                      <v-layout row wrap>
                                          <v-col cols="12" v-for="unit in reservation.units">
                                              <b>{{ unit.rate_type.name }}</b>
                                              <div>{{ unit.rate_type.policy_payment_text }}</div>
                                          </v-col>
                                      </v-layout>
                                  </v-col>


                                  <!--
                                  <v-col cols="9" v-for="unit in reservation.units">
                                      <strong>{{ unit.rate_type.name }}</strong>
                                      <div v-if="reservation.type_of_hotel != 'ARR'">{{ unit.policy_payment_text }}</div>
                                      <textarea v-model="unit.policy_payment_text" 
                                                v-if="reservation.type_of_hotel == 'ARR'"></textarea>
                                  </v-col>
                                  -->
                                  

<!--                            
                                  <v-col cols="9">
                                      <v-layout row wrap>
                                          <v-col cols="12"  v-for="policy in getRateTypePolicies(reservation)">
                                              <div><strong>{{ policy.name }}</strong></div>
                                              <div>{{ policy.text }}</div>
                                          </v-col>
                                      </v-layout>
                                  </v-col>
-->
                                  <v-col cols="12" md="3">
                                      <strong>Cancellation Policy:</strong>
                                  </v-col>

                                  <v-col cols="12" md="9">
                                      <div v-for="unit in reservation.units">
                                      <v-layout row wrap>
                                          <v-col cols="12"  v-for="policy in getCancellationPolicies(reservation)">
                                              <div><strong>{{ policy.name }}</strong></div>
                                              <!--<div>{{ policy.text }}</div>-->
                                              <textarea v-model="policy.text"></textarea>
                                          </v-col>
                                      </v-layout>
                                      </div>

                                  </v-col>
                                  <!-- End per unit -->



                               <v-col cols="12" md="3">
                                   <strong>{{ reservation.hotel.is_tailormade_tour ? "Quote Valid Until" : "Room Held Until" }}</strong>
                               </v-col>

                               <v-col cols="12" md="9">
                                   <v-date-picker v-model="reservation.quote_expiry" no-title scrollable>
                                   </v-date-picker> at midnight (GMT)
                                   <div><strong>NOTE</strong> this shows {{ reservation.hotel.holds_rooms }} days from now. Please change it if you cannot keep the room/s on option for {{ reservation.hotel.holds_rooms }} days. Ensure that you keep the accommodation/service quoted on available for the specified validity period.</div>
                               </v-col>

                              </v-layout>
                          </v-container>
                      </v-card-text>

                      <v-card-actions>
                          <v-btn class="ies-green" v-on:click="sendQuote">Send to client</v-btn>
                      </v-card-actions>
                 </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    /**
     * A Vue component dedicated to letting the user issue a quote
     * by the reservation ID specified
     *
     * Props:
     *     int 'reservationkey' - The ID of the reservation to display
     */

    import axios from 'axios';
    import EventBus from '@/eventBus';
    export default {
        name: 'hotel-reservation-enquiry',
        props: ['reservationkey'],
        data () {
            return {
                reservation: {},
                defaultCancellationPolicy: "",
                quote: {},
                quoteNotPossible: 0,
                totalRates: 0.0
            }
        },
        methods: {

            loadReservation(){
                axios.get('/api/reservations/id/' + this.reservationkey)
                .then(function(response){
                    this.reservation = response.data.reservation;

                    // Set a property to dictate whether the booking would require the client to pay a deposit
                    // The logic being if i-escape collects one for the hotel, or the rates require one, or the
                    // hotel's policy requires it for all bookings
                    console.log("quote accept: ",this.reservation);
                    this.reservation.depositRequired = this.reservation.hotel.collect_deposit || this.reservation.is_advance_payment || ((this.reservation.hotel.hotel_payment_policy.deposit_required == 1) || (this.reservation.hotel.hotel_payment_policy.deposit_required == 2));
                    if (!this.reservation.quote_expiry){
                        var date = new Date();
                        date.setDate(date.getDate() + 5);
                        this.reservation.quote_expiry = date.getUTCFullYear() +"-"+ (date.getUTCMonth()+1) +"-"+ date.getUTCDate();
                    }

                    var startDate = Date.parse(this.reservation.date_arrival);
                    console.log(startDate);
                    for(var index=0; index < this.reservation.stay_length; index++){
                        var datePointer = new Date(startDate.valueOf());
                        datePointer.setDate(datePointer.getDate() + index);
                        var dateString = datePointer.getUTCDate() + " " + this.getMonthAbbreviated(datePointer.getUTCMonth()) + " " + datePointer.getUTCFullYear() + ', ' + this.getDayAbbreviated(datePointer.getDay())
                        //this.quote.push({ "dateString": dateString, "date": date, "rateValue": 0.0 })
                    }
                    console.log(this.dateRange);


                    console.log("offer quote: ", this.reservation);

                    // Set up view models with initial values
                    this.updateTotalRatesFromSeparateRates();

                    // Set the default value for the cancellation policy text area ready for editing by the user
                    //this.setDefaultCancellationPolicy();
                }.bind(this));
            },
/*
            makeEmptyQuote(reservation){
                var quote = {rooms: []};
                reservation.units.forEach(function(unit){
                   quote. 
                });
                this.quote = quote;
            },
*/
            sendQuote(){
                axios.post('/api/reservations/' + this.reservationkey + '/send-quote', {"reservation": this.reservation})
                .then(function(response){
                    alert("Quote sent to client");
                    EventBus.$emit('Reservation Administration: Reservation changed', {'reservationKey': this.reservationkey});
                }.bind(this));
            },

/*
            setDefaultCancellationPolicy(){
                var policies = this.getCancellationPolicies(this.reservation);
                var self = this;
                policies.forEach(function(policy){
                    self.defaultCancellationPolicy += ((self.defaultCancellationPolicy != "" ? "\n\n" : "") + policy.text);
                });
            },
*/

            /**
             * Returns the day of the week by abbreviated name
             * e.g. 1 = "Mon", 2 = "Tue" etc
             */
            getDayAbbreviated(dayIndex){
                var days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
                return days[dayIndex];
            },

            /**
             * Returns the month of the year by abbreviated name
             * e.g. 1 = "Feb", 2 = "Mar" etc
             */
            getMonthAbbreviated(monthIndex){
                var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                return months[monthIndex];
            },


            /**
             * @method dateFormatDDMYYYYDay
             *
             * Takes a date string in the format YYYY-MM-DD and returns it in the designed format
             * e.g. '17 September 2025, Wednesday'
             *
             * @param String dateString
             * @return String
             */
            dateFormatDDMYYYYDay(dateString){
               var parts = dateString.replace('T', '-').split('-');
               var myDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]), 0, 0, 0);
               return myDate.getDate() + " " + this.getMonthName(myDate.getMonth()) + " " + myDate.getFullYear() + ", " + this.getDayName(myDate.getDay());
            },

            getMonthName(monthIndex){
                switch(monthIndex){
                    case 0: return "January";
                    case 1: return "February";
                    case 2: return "March";
                    case 3: return "April";
                    case 4: return "May";
                    case 5: return "June";
                    case 6: return "July";
                    case 7: return "August";
                    case 8: return "September";
                    case 9: return "October";
                    case 10: return "November";
                    case 11: return "December";
                }
                return "Unknown";
            },


            getDayName(dayIndex){
                switch(dayIndex){
                    case 0: return "Sunday";
                    case 1: return "Monday";
                    case 2: return "Tuesday";
                    case 3: return "Wednesday";
                    case 4: return "Thursday";
                    case 5: return "Friday";
                    case 6: return "Saturday";
                }
                return "Unknown";
            },


            /**
             * @method
             *
             * @param object reservation
             * @return array of view models for listing the payment policies
             * for the various rate types applied to this reservation without
             * duplication or requiring excessive processing in the view template
             */
            getRateTypePolicies(reservation){
                var policies = [];
                reservation.units.forEach(function(unit){
                    policies.push({'name': unit.rate_type.name, 'text': unit.rate_type.policy_payment_text});
                });
                return policies;
            },

            updateTotalRatesFromSeparateRates(){
                var totalRates = 0.00;
                this.reservation.units.forEach(function(unit){
                    unit.std_rates.forEach(function(stdRate){
                        totalRates += Math.max(0.0, stdRate.rate);
                    });
                });
                this.totalRates = totalRates;

                // Update the rest of the fields such as commssion/deposit
                this.reservation.commission_amount_local = ((this.totalRates / 100) * this.reservation.hotel.commission_agreed);
                this.reservation.deposit_amount_local = ((this.totalRates / 100) * this.reservation.hotel.commission_agreed);
            },


            updateSeparateRatesFromTotalRates: function () {
                var pricePerEntry = 0.00;
                var totalNumEntries = 0;

                // Before we can divide the total price evenly across the quote
                // we need to know how many things we are dividing it between
                // so we can calculate the individual price values
                this.reservation.units.forEach(function(unit){
                    unit.std_rates.forEach(function(stdRate){
                        totalNumEntries++;
                    });
                });
              
                // Calculate the price per entry needed to add up to the total quote price
                pricePerEntry = Math.max(1.0, parseFloat(this.totalRates)) / totalNumEntries; 

                // Update the individual values to this such that the entire quote will
                // add up to the value the hotelier just plucked from the sky
                this.reservation.units.forEach(function(unit){
                    unit.std_rates.forEach(function(stdRate){
                        stdRate.rate = pricePerEntry;
                    });
                });

                // Update the rest of the fields such as commssion/deposit
                this.reservation.commission_amount_local = ((this.totalRates / 100) * this.reservation.hotel.commission_agreed);
                this.reservation.deposit_amount_local = ((this.totalRates / 100) * this.reservation.hotel.commission_agreed);
		    },


            getCancellationPolicies(reservation){
                var policies = [];
                reservation.units.forEach(function(unit){
                    if (unit.cancellation_policy){
                        policies.push({'name': unit.rate_type.name, 'text': unit.cancellation_policy.policy_cancel_text});
                    }
                });
                return policies;
            },
        },

        /**
         * Once mounted this component needs to load the reservation specified
         */
        mounted() {
            this.loadReservation();
        },

        computed: {},

/*
        watch: {
            totalRates: function (newValue) {
                var pricePerEntry = 0.00;
                var totalNumEntries = 0;

                // Before we can divide the total price evenly across the quote
                // we need to know how many things we are dividing it between
                // so we can calculate the individual price values
                this.reservation.units.forEach(function(unit){
                    unit.std_rates.forEach(function(stdRate){
                        totalNumEntries++;
                    });
                });
              
                // Calculate the price per entry needed to add up to the total quote price
                pricePerEntry = Math.max(1.0, parseFloat(newValue)) / totalNumEntries; 

                // Update the individual values to this such that the entire quote will
                // add up to the value the hotelier just plucked from the sky
                this.reservation.units.forEach(function(unit){
                    unit.std_rates.forEach(function(stdRate){
                        stdRate.rate = pricePerEntry;
                    });
                });
		    }
        }
*/
    }
</script>
